import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User saves their transcript edit',
  name: 'transcription_save_edit',
};

export default META;
